import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { DateiViewApiService, DateiVO } from "@core/api/v1";
import { Location } from '@angular/common';


@Component({
  selector: 'app-file-download',
  standalone: true,
  imports: [],
  templateUrl: './file-download.component.html',
  styleUrl: './file-download.component.scss'
})
export class FileDownloadComponent implements OnInit{
    downloadId: string | null;
    data: DateiVO;

    constructor(private route: ActivatedRoute, private api: DateiViewApiService, private location: Location) {}

    ngOnInit() {
        this.route.queryParamMap.subscribe(params => {
            this.downloadId = params.get('downloadId');
        });
        if(this.downloadId === null) return;
        this.api.show(this.downloadId).subscribe(response => {
            this.data = response;
            this.downloadFile();
        })
    }

    downloadFile() {
        let contentType = this.data.fileName!.split('.').pop()?.toLowerCase() || '';
        this.downloadBase64File(this.data.base64!, this.data.fileName!, contentType);
    }
    downloadBase64File(base64Data: string, fileName: string, contentType: string) {

        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();

        // 5. Objekt-URL wieder freigeben
        window.URL.revokeObjectURL(link.href);

        this.location.back();
    }
}
